import { format, parseISO } from 'date-fns';

/**
 * Formats an ISO date string (e.g. '2026-03-11') according to the
 * user's chosen date format preference stored in settings.
 */
export function formatDateByPreference(dateStr: string, dateFormat: string): string {
  const date = parseISO(dateStr);
  switch (dateFormat) {
    case 'MM/DD/YYYY':
      return format(date, 'MM/dd/yyyy');
    case 'DD/MM/YYYY':
      return format(date, 'dd/MM/yyyy');
    case 'DD/Month/YYYY':
      return format(date, 'dd MMM yyyy');
    case 'YYYY-MM-DD':
      return format(date, 'yyyy-MM-dd');
    case 'Month Day, YYYY':
      return format(date, 'MMMM d, yyyy');
    default:
      return format(date, 'MM/dd/yyyy');
  }
}
